// import { getTranslations } from 'next-intl/server';
'use client';
import CustomLink from '@/components/CustomLink';
import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';

type ButtonProps = {
  label: string;
  link: string;
  btnId: string;
  type: string;
  isExternal?: boolean;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({ type, label, link, btnId, isExternal, className = '' }) => {
  const lang = useLocale();
  const [urlRedirection, setUrlRedirection] = useState('');
  const [langPrefix, setLangPrefix] = useState('en');

  useEffect(() => {
    const host = window.location.hostname;
    const domainTarget = host.startsWith('www.') ? host.replace(/^www\./, 'dashboard.') : `dashboard.${host}`;
    setUrlRedirection(domainTarget);

    let newLang = 'en';
    switch (lang) {
      case 'sc':
        newLang = 'zh';
        break;
      case 'tc':
        newLang = 'zh-TW';
        break;
      case 'kr':
        newLang = 'ko';
        break;
      case 'jp':
        newLang = 'ja';
        break;
      case 'vn':
        newLang = 'vi';
        break;
      case 'pe':
        newLang = 'fa';
        break;
      default:
        newLang = lang;
    }
    setLangPrefix(newLang);
  }, [lang]);

  return (
    <CustomLink
      className={`btn ${type} ${className}`}
      href={isExternal ? link : `https://${urlRedirection}/${langPrefix}/${link}`}
      id={btnId}
      target="_blank"
    >
      {label}
    </CustomLink>
  );
};
export default Button;
